/** WCKT / 9Wicket uses DSTONE wallet-login URLs, not iframe HTML. */

export function isWcktLaunchProvider(providerCode) {
  const code = String(providerCode || '').trim().toUpperCase();
  return code === 'WCKT' || code === '9WICKET';
}

/** iGaming 9Wicket (World Casino): provider 141 + game 11539. Not DST WCKT. */
export const IGAMING_9W_API_COMPANY = 'igaming';
export const IGAMING_9W_PROVIDER_CODE = '141';
export const IGAMING_9W_GAME_CODE = '11539';

export function isIgaming9WicketLaunch(providerCode, gameCode, apiCompanyId) {
  const company = String(apiCompanyId || '').trim().toLowerCase();
  if (company && company !== IGAMING_9W_API_COMPANY) {
    return false;
  }
  const provider = String(providerCode || '').trim();
  const game = String(gameCode || '').trim();
  if (game === IGAMING_9W_GAME_CODE) {
    return true;
  }
  if (provider === IGAMING_9W_PROVIDER_CODE && (game === '' || game === '0')) {
    return true;
  }
  return provider === IGAMING_9W_PROVIDER_CODE && game === IGAMING_9W_GAME_CODE;
}

export function isHttpLaunchUrl(url) {
  try {
    const parsed = new URL(String(url || '').trim());
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

export function sanitizeLaunchUrlForLog(url) {
  try {
    const parsed = new URL(String(url || '').trim());
    return `${parsed.protocol}//${parsed.host}${parsed.pathname}`;
  } catch {
    return '';
  }
}

export function navigateTopLevelLaunch(url, assign) {
  const href = String(url || '').trim();
  if (!isHttpLaunchUrl(href)) return false;
  const go = typeof assign === 'function'
    ? assign
    : (target) => {
      window.location.assign(target);
    };
  go(href);
  return true;
}

function browserOpen() {
  return typeof window !== 'undefined' && typeof window.open === 'function'
    ? window.open.bind(window)
    : null;
}

/**
 * Do not open about:blank. This browser creates that tab even when window.open
 * returns no handle, and the tab then cannot be navigated or closed.
 * A real vendor URL is opened only after the launch response.
 */
export function openNineWicketPlaceholder() {
  return null;
}

export function closeNineWicketPlaceholder(child) {
  if (!child) return;
  try {
    if (!child.closed) child.close();
  } catch { /* ignore */ }
}

/**
 * Put the vendor launch URL in the tab opened for this click.
 * Does not navigate the current Alfa9 page.
 */
function sealOpener(child) {
  try { child.opener = null; } catch { /* already cross-origin */ }
}

export function openNineWicketLaunch(url, child, openImpl) {
  const href = String(url || '').trim();
  if (!isHttpLaunchUrl(href)) {
    closeNineWicketPlaceholder(child);
    return false;
  }
  if (child) {
    try {
      if (!child.closed) {
        child.location.replace(href);
        sealOpener(child);
        return true;
      }
    } catch {
      closeNineWicketPlaceholder(child);
      return false;
    }
  }
  closeNineWicketPlaceholder(child);
  const open = typeof openImpl === 'function' ? openImpl : browserOpen();
  if (!open) return false;
  try {
    const next = open(href, '_blank');
    if (next) sealOpener(next);
    return true;
  } catch {
    return false;
  }
}
